import { useState, useEffect } from "react";
import { News } from "@/models/database/news/News.model";
import { useNewsStore } from "@/store/news/news.store";
import {
  collectionDoc,
  collectionRef,
} from "@/api/collectionRef/collectionOperations";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";

const useSingleNews = (slug: string) => {
  const [newsItem, setNewsItem] = useState<News | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);
  const newsStore = useNewsStore();

  useEffect(() => {
    const fetchNewsItem = async () => {
      try {
        const storedNewsItem = newsStore.getNewsBySlug(slug);
        if (storedNewsItem) {
          setNewsItem(storedNewsItem);
          setLoading(false);
          return;
        }

        const querySnapshot = await collectionRef
          .news(brand.tenantId)
          .where("slug", "==", slug)
          .limit(1)
          .get();

        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];

          const profileDoc = await collectionDoc.profiles(
            doc.data().createdBy,
            brand.tenantId
          );

          setNewsItem({
            ...doc.data(),
            author: {
              fullName: profileDoc.data().fullName,
              profileLogoUrl: profileDoc.data().profileLogoUrl,
              slug: profileDoc.data().slug,
              uid: profileDoc.data().uid,
              userName: profileDoc.data().userName,
            },
          } as News);
        } else {
          setError(Error("No news item found with the given slug"));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNewsItem();
  }, [slug]);

  return { newsItem, loading, error };
};

export default useSingleNews;
